import { Select } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { SortKey } from '../../utils/sort'

type TeamListSortDropdownProps = {
  value: SortKey
  onChange: (value: SortKey) => void
  testId?: string
}

const StyledSelect = styled(Select<SortKey>)`
  width: 200px;
`

const SORT_LABEL_KEYS: Record<SortKey, string> = {
  'recently-added': reportsConstants.TEAM_LIST_SORT_RECENTLY_ADDED,
  'first-added': reportsConstants.TEAM_LIST_SORT_FIRST_ADDED,
  'first-name-asc': reportsConstants.TEAM_LIST_SORT_FIRST_NAME_ASC,
  'first-name-desc': reportsConstants.TEAM_LIST_SORT_FIRST_NAME_DESC
}

const TeamListSortDropdown: React.FC<TeamListSortDropdownProps> = ({
  value,
  onChange,
  testId
}) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  const options = (Object.keys(SORT_LABEL_KEYS) as SortKey[]).map((key) => ({
    value: key,
    label: t(SORT_LABEL_KEYS[key])
  }))

  return (
    <StyledSelect
      value={value}
      options={options}
      onChange={(next) => onChange(next as SortKey)}
      aria-label={t(reportsConstants.TEAM_LIST_SORT_ARIA)}
      data-testid={testId}
    />
  )
}

export default TeamListSortDropdown
